<div>
    <!-- Header -->
    <h1 mat-dialog-title class="text-center font-weight-bold">Import Twilio Phone Number</h1>

    <mat-divider></mat-divider>

    <!-- Content -->
    <mat-dialog-content>
        <app-user-phone-numbers class="text-dark" [aiAgent]="aiAgent"></app-user-phone-numbers>
    </mat-dialog-content>

    <mat-divider></mat-divider>

    <!-- Actions -->
    <div mat-dialog-actions class="d-flex justify-content-around">
        <button mat-raised-button mat-dialog-close color="warn" class="w-25">Cancel</button>
    </div>
</div>